import { DefaultActions, Separator, Showing, Total, Search, Wrapper, GridToggles } from '@/components/Grid/components/header/Heading';
import { DefaultGrid, GridProvider, GridTableSortable, useBuildGrid } from '@Components/Grid';

import { useRetargetingStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'
import useFilters from './useFilters'

function RetargetingGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
    events: useEvents(),
  })

  return <DefaultGrid
    heading={<Wrapper>
      <Search />
      <Separator />
      <GridToggles />
      <Separator />
      <Total />
      <Showing />
      <Separator />
      <DefaultActions />
    </Wrapper>}
    table={<GridTableSortable />}
  />
}

export default function RetargetingGridLayout() {
  return <GridProvider store={useRetargetingStore()}>
    <RetargetingGrid />
  </GridProvider>
}
